export * from './core.module';
export * from './authentication/authentication.service';
export * from './authentication/authentication.service.mock';
export * from './authentication/authentication.guard';
export * from './i18n.service';
export * from './utils.service';
export * from './http/http.service';
export * from './http/http-cache.service';
export * from './route.service';
export * from './route-reusable-strategy';
export * from './logger.service';



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/core/index.ts